import { clientOnlyLazy } from 'components/ClientOnlySuspense/clientOnlyLazy';
import LoadingModal from 'modals/LoadingModal';

export const StaffGradFairRemoveFromWaitlistModalContainerLoadable =
  clientOnlyLazy({
    loader: () =>
      import(
        /* webpackChunkName: "StaffGradFairRemoveFromWaitlistModalContainer" */
        './StaffGradFairRemoveFromWaitlistModalContainer.dynamic'
      ),
    loading: LoadingModal,
  });
